<template>
  <div>
    <Loader
      v-show="loading"
      :loading="loading"
    />
    <v-card v-if="errorException">
      <v-row
        align="center"
        class="pa-3 ma-3"
      >
        <v-icon
          small
          color="orange darken-3"
        >
          report_problem
        </v-icon>
        <span class="orange--text text--darken-3 align-center">{{
          errorException
        }}</span>
        <v-spacer />
        <IconBtn
          icons="close"
          :large="true"
          color="grey darken-4"
          @click="close"
        />
      </v-row>
    </v-card>
    <v-card v-else>
      <v-card-title>
        <v-row no-gutters>
          <span class="headline font-weight-medium">{{ header }}</span>
          <v-spacer />
          <IconBtn
            icons="close"
            :large="true"
            color="grey darken-4"
            @click="close"
          />
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <CustomTextField
              v-model="title"
              label="Назва"
              :hide-details="true"
              :required="true"
              :error-messages="$v.title.$invalid ? errors.TITLE : []"
              @input="isChanged = true"
            />
          </v-col>
          <v-col>
            <CustomTextField
              v-model="site"
              label="Сайт"
              :hide-details="true"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <ContactsSelect
              v-model="contacts"
              :multiple-select="true"
              label="Контакти"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
        <v-row v-show="agreements.length > 0">
          <v-col>
            <AgreementsSelect
              v-model="agreements"
              :multiple-select="true"
              label="Угоди"
              :disabled="true"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <PrimaryBtn
          :loading="loading"
          :disabled="!isChanged || isFormInvalid"
          @click="save"
        />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import * as companiesApi from "../../backend/companiesApi.js";
import Loader from "../../../components/Loader.vue";
import IconBtn from "../../../components/IconBtn.vue";
import PrimaryBtn from "../../../components/PrimaryBtn.vue";
import CustomTextField from "../../../components/CustomTextField.vue";
import { ERRORS } from "@/helpers";
import { required } from "vuelidate/lib/validators";
import ContactsSelect from "../contacts/ContactsSelect.vue";
import AgreementsSelect from "../agreements/AgreementSelect.vue";

export default {
  components: {
    Loader,
    IconBtn,
    PrimaryBtn,
    CustomTextField,
    ContactsSelect,
    AgreementsSelect,
  },
  props: ["id"],
  data: () => ({
    loading: false,
    errorException: "",
    isChanged: false,
    title: "",
    site: "",
    contacts: [],
    agreements: [],
  }),
  validations: {
    title: {
      required,
    },
  },
  computed: {
    isFormInvalid(){
      return this.$v.title.$invalid;
    },
    isNew() {
      return this.id != 0 ? false : true;
    },
    header() {
      return this.isNew ? "Створення компанії" : "Редагування компанії";
    },
    errors() {
      return {
        TITLE: [ERRORS.REQUIRED],
      };
    },
  },
  created() {
    if (this.id != 0) {
      companiesApi.getCompany(this.id).then((entity) => {
        this.title = entity.title;
        this.site = entity.webSite;
        this.contacts = entity.contacts;
        this.agreements = entity.agreements;
      });
    }
  },
  methods: {
    async save() {
      this.loading = true;
      var contactIds = this.contacts.map(e=>{
        return e.id;
      });
      var newEntity = { title: this.title, website: this.site, contacts: contactIds };
      if (this.id == 0) {
        await companiesApi
          .createCompany(newEntity)
          .then(() => {
            this.$router.push({ path: "/crm-companies" });
          });
      } else {
        await companiesApi.updateCompany(this.id, newEntity);
        this.$notifySuccess();
      }
      this.loading = false;
    },
    close() {
      if (this.modal) {
        this.$emit("close");
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>